import React, { useState, useEffect } from 'react'
import Header from '../header/header'
import Footer from '../footer/footer'
import { getTermsAndCondition } from '../services';
import Skeleton from "../auth/component/skeleton";
import DOMPurify from "dompurify";

const TermsAndCondition = () => {
  const [TermsAndConditions, setTermsAndConditions] = useState({})
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getTermsAndConditions()
  }, [])


  const getTermsAndConditions = async () => {
    try {
      const res = await getTermsAndCondition('terms_and_conditions')
      console.log(res.data[0])
      await setTermsAndConditions(res.data[0])
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <section >
      <div className='bg-white'>
        <div className='h-full'>
          <Header />
          <div className='grid grid-cols-1 bg-white container py-5'>
            {loading ?
              (
                <>
                  <div className="flex flex-col items-center bg-white shadow-md rounded-lg p-4">
                    <Skeleton width='100%' />
                  </div>
                </>
              ) :
              (
                <>
                  <div
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(TermsAndConditions.content) }}
                    className="html-container"
                  />
                </>
              )
            }
          </div>
          <Footer />

        </div>
      </div>
      {/* <Footer /> */}

    </section>
  )
}

export default TermsAndCondition